import { render, staticRenderFns } from "./CustomerAddress.vue?vue&type=template&id=7b16d49c&"
import script from "./CustomerAddress.vue?vue&type=script&lang=js&"
export * from "./CustomerAddress.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAddress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1751410358/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b16d49c')) {
      api.createRecord('7b16d49c', component.options)
    } else {
      api.reload('7b16d49c', component.options)
    }
    module.hot.accept("./CustomerAddress.vue?vue&type=template&id=7b16d49c&", function () {
      api.rerender('7b16d49c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/CustomerAddress.vue"
export default component.exports